<template>
  <v-dialog v-model="dialog" max-width="500" persistent>
    <v-card>
      <v-card-title class="headline">
        {{ titulo }}
      </v-card-title>

      <v-card-text>
        <slot>
          {{ mensaje }}
        </slot>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text :disabled="realizandoAccion" @click="cancelar">
          {{ textoCancelar }}
        </v-btn>

        <v-btn color="primary" :loading="realizandoAccion" :disabled="realizandoAccion" @click="aceptar">
          {{ textoAceptar }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmacionAccion',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    titulo: {
      type: String,
      default: 'Confirmar acción',
    },
    mensaje: {
      type: String,
      default: '¿Está seguro de realizar esta acción?',
    },
    realizandoAccion: {
      type: Boolean,
      default: false,
    },
    textoAceptar: {
      type: String,
      default: 'Aceptar',
    },
    textoCancelar: {
      type: String,
      default: 'Cancelar',
    },
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    aceptar() {
      this.$emit('aceptar');
    },
    cancelar() {
      this.$emit('cancelar');
      this.dialog = false;
    },
  },
};
</script>